// extracted by mini-css-extract-plugin
module.exports = {"connectWithStripe":"ConnectTab_connectWithStripe__1O8me","paymentMethodLink":"ConnectTab_paymentMethodLink__3fJiG","stripeButton":"ConnectTab_stripeButton__25DwU"};